import {
    getCoverLayer,
    getDrainageChimneyHeight,
    getDrainageChimneyLength,
    getDrainLineLengthPrimaryDrainageTrench,
    getDrainLineLengthSecondaryDrainageTrench,
    getExpectedWaterTableDepth,
    getHeightOfSaturatedWaterTableBelowDrains,
    getNumberOfDrainLinesPrimaryDrainageTrench,
    getNumberOfDrainLinesSecondaryDrainageTrench,
    getWaterTableLoweringThickness,
} from '../../../calculation';
import { redux } from '../../../store';
import { EDrainageTrenchType, EPosition } from '../../enum';
import { IInputDrainageChimney, IInputDrainageTrench } from '../../iProject';

export const handleConfigurationSwap = (drainageTrenches: IInputDrainageTrench[], drainageChimney: IInputDrainageChimney[], index: EDrainageTrenchType) => {
    const { drainHeight, drainUnitWidth, drainUnitLength, drainPositionDepth } = drainageTrenches[index];
    const { configuration, coverLayer } = drainageChimney[index];

    drainageTrenches[index].drainUnitWidth = drainHeight;
    drainageTrenches[index].drainHeight = drainUnitWidth;
    drainageChimney[index].drainageChimneyLength = getDrainageChimneyLength(configuration as EPosition, drainUnitLength!, drainageTrenches[index].drainHeight!);
    drainageChimney[index].drainageChimneyHeight = getDrainageChimneyHeight(configuration as EPosition, drainUnitLength!, coverLayer!, drainHeight!, drainPositionDepth!);
    drainageChimney[index].coverLayer = getCoverLayer(drainPositionDepth!, drainageTrenches[index].drainHeight!, drainageChimney[index].drainageChimneyHeight);
};

export const handleDrainPositionDepth = (value: number, drainageTrenches: IInputDrainageTrench[], drainageChimney: IInputDrainageChimney[]) => {
    const project = redux.getState().project;
    const { impermeableLayerDepth } = project.data?.slope!;

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].expectedWaterTableDepth = getExpectedWaterTableDepth(value);
    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains = getHeightOfSaturatedWaterTableBelowDrains(
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].hasWaterproofMembraneBelowDrain!,
        value,
        impermeableLayerDepth!,
    );
    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].waterTableLoweringThickness = getWaterTableLoweringThickness(
        value,
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].expectedWaterTableDepth!,
    );
    drainageChimney[EDrainageTrenchType.PrimaryDrainageTrench].drainageChimneyHeight = getDrainageChimneyHeight(
        drainageChimney[EDrainageTrenchType.PrimaryDrainageTrench].configuration as EPosition,
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].drainUnitLength!,
        drainageChimney[EDrainageTrenchType.PrimaryDrainageTrench].coverLayer!,
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].drainHeight!,
        value,
    );
    drainageChimney[EDrainageTrenchType.PrimaryDrainageTrench].coverLayer = getCoverLayer(
        value,
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].drainHeight!,
        drainageChimney[EDrainageTrenchType.PrimaryDrainageTrench].drainageChimneyHeight,
    );

    if (hasSecondaryDrainageTrench) {
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainPositionDepth = value;
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].expectedWaterTableDepth = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].expectedWaterTableDepth;
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains =
            drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains;
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].waterTableLoweringThickness = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].waterTableLoweringThickness;
        drainageChimney[EDrainageTrenchType.SecondaryDrainageTrench].drainageChimneyHeight = getDrainageChimneyHeight(
            drainageChimney[EDrainageTrenchType.SecondaryDrainageTrench].configuration as EPosition,
            drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainUnitLength!,
            drainageChimney[EDrainageTrenchType.SecondaryDrainageTrench].coverLayer!,
            drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainHeight!,
            value,
        );
        drainageChimney[EDrainageTrenchType.SecondaryDrainageTrench].coverLayer = getCoverLayer(
            value,
            drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainHeight!,
            drainageChimney[EDrainageTrenchType.SecondaryDrainageTrench].drainageChimneyHeight,
        );
    }
};

export const handleWheelbaseChange = (value: number, drainageTrenches: IInputDrainageTrench[], index: EDrainageTrenchType) => {
    const project = redux.getState().project;
    const { slopeWidth, slopeLength } = project.data?.slope!;

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    if (index === EDrainageTrenchType.PrimaryDrainageTrench) {
        if (hasSecondaryDrainageTrench) drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainLineLength = getDrainLineLengthSecondaryDrainageTrench(value);
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].numberOfDrainLines = getNumberOfDrainLinesPrimaryDrainageTrench(slopeWidth!, value);
    } else {
        if (hasSecondaryDrainageTrench) drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].numberOfDrainLines = getNumberOfDrainLinesSecondaryDrainageTrench(slopeLength!, value);
    }
};

export const handleWaterproofMembraneChange = (value: boolean, drainageTrenches: IInputDrainageTrench[]) => {
    const project = redux.getState().project;
    const { impermeableLayerDepth } = project.data?.slope!;
    const { drainPositionDepth } = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench];

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains = getHeightOfSaturatedWaterTableBelowDrains(value, drainPositionDepth!, impermeableLayerDepth!);
    if (hasSecondaryDrainageTrench) {
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains =
            drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains;
    }
};

export const handleExpectedWaterTableDepthChange = (value: number, drainageTrenches: IInputDrainageTrench[], index: EDrainageTrenchType) => {
    const project = redux.getState().project;
    const { drainPositionDepth } = drainageTrenches[index];

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].waterTableLoweringThickness = getWaterTableLoweringThickness(drainPositionDepth!, value);

    if (hasSecondaryDrainageTrench) {
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].expectedWaterTableDepth = value;
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].waterTableLoweringThickness = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].waterTableLoweringThickness;
    }
};

export const handleDrainChange = (drainageTrenches: IInputDrainageTrench[], drainageChimney: IInputDrainageChimney[], index: EDrainageTrenchType) => {
    const { configuration, coverLayer } = drainageChimney[index];
    const { drainPositionDepth, drainUnitLength, drainHeight } = drainageTrenches[index];

    drainageChimney[index].drainageChimneyLength = getDrainageChimneyLength(configuration as EPosition, drainUnitLength!, drainHeight!);
    drainageChimney[index].drainageChimneyHeight = getDrainageChimneyHeight(configuration as EPosition, drainUnitLength!, coverLayer!, drainHeight!, drainPositionDepth!);
    drainageChimney[index].coverLayer = getCoverLayer(drainPositionDepth!, drainHeight!, drainageChimney[index].drainageChimneyHeight);
};

export const handleImpermeableLayerDepthChange = (value: number, drainageTrenches: IInputDrainageTrench[]) => {
    const project = redux.getState().project;
    const { hasWaterproofMembraneBelowDrain, drainPositionDepth } = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench];

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains = getHeightOfSaturatedWaterTableBelowDrains(
        hasWaterproofMembraneBelowDrain!,
        drainPositionDepth!,
        value,
    );
    if (hasSecondaryDrainageTrench) {
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains =
            drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].heightOfSaturatedWaterTableBelowDrains;
    }
};

export const handleSlopeWidthChange = (value: number, drainageTrenches: IInputDrainageTrench[]) => {
    const { wheelbase } = drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench];
    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].numberOfDrainLines = getNumberOfDrainLinesPrimaryDrainageTrench(value, wheelbase!);
};

export const handleSlopeLengthChange = (value: number, drainageTrenches: IInputDrainageTrench[]) => {
    const project = redux.getState().project;

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].drainLineLength = getDrainLineLengthPrimaryDrainageTrench(value);
    if (hasSecondaryDrainageTrench) {
        const { wheelbase } = drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench];
        drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].numberOfDrainLines = getNumberOfDrainLinesSecondaryDrainageTrench(value, wheelbase!);
    }
};

export const handleConfigurationChange = (value: number, index: EDrainageTrenchType, drainageChimney: IInputDrainageChimney[], drainageTrenches: IInputDrainageTrench[]) => {
    const { drainUnitLength, drainHeight, drainPositionDepth } = drainageTrenches[index];
    const { coverLayer } = drainageChimney[index];

    drainageChimney[index].drainageChimneyLength = getDrainageChimneyLength(value, drainUnitLength!, drainHeight!);
    drainageChimney[index].drainageChimneyHeight = getDrainageChimneyHeight(value, drainUnitLength!, coverLayer!, drainHeight!, drainPositionDepth!);
    drainageChimney[index].coverLayer = getCoverLayer(drainPositionDepth!, drainHeight!, drainageChimney[index].drainageChimneyHeight);
};

export const handleDrainageChimneyHeightChange = (value: number, index: EDrainageTrenchType, drainageChimney: IInputDrainageChimney[], drainageTrenches: IInputDrainageTrench[]) => {
    const { drainHeight, drainPositionDepth } = drainageTrenches[index];

    drainageChimney[index].coverLayer = getCoverLayer(drainPositionDepth!, drainHeight!, value);
};

export const handleDrainSingleChange = (value: boolean, drainageTrenches: IInputDrainageTrench[]) => {
    const project = redux.getState().project;
    const { slopeWidth } = project.data?.slope!;

    const hasSecondaryDrainageTrench = project.data?.drainageTrenches?.length! > 1;

    if (value) {
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].numberOfDrainLines = 1;
        drainageTrenches[EDrainageTrenchType.PrimaryDrainageTrench].wheelbase = slopeWidth;
        if (hasSecondaryDrainageTrench) drainageTrenches[EDrainageTrenchType.SecondaryDrainageTrench].drainLineLength = getDrainLineLengthSecondaryDrainageTrench(slopeWidth!);
    }
};
